import React, { useEffect, useState } from "react";
import Head from "next/head";
import Hero from "../components/contact/Hero";
import Form from "../components/contact/Form";
import PageName from "../components/pagename/index";
import useLocaleSWR from "../components/customhooks/useLocalSwr";
import { useRouter } from "next/router";
import axios from "../Axios";
import { useTranslations } from "next-intl";
function contact({ countries }) {
  const t = useTranslations("contactUsPage");

  return (
    <>
      <Head>
        <title>Contact Ascot | Ascot Enterprise Solutions</title>
      </Head>
      <PageName title={t("title")} img="contact/mail" />

      <div className="responsive max-w-[1440px] xl:m-auto flex flex-col xlg:flex-row-reverse min-h-[100vh] xlg:gap-x-10 xl:gap-x-[125px]  pt-6 xl:pt-[80px]  xlg:pt-20">
        <Hero />
        <Form country={countries} />
      </div>
    </>
  );
}

export default contact;

export async function getServerSideProps({ locale }) {
  const allCountries = await axios.get("user/country");
  const countries = allCountries.data.data[0].country;

  return {
    props: {
      countries,
      messages: require(`../locales/${locale || "en"}.json`),
    },
  };
}
